import { render, staticRenderFns } from "./IndexPortfolio.vue?vue&type=template&id=d5cc1746&scoped=true&"
import script from "./IndexPortfolio.vue?vue&type=script&setup=true&lang=ts&"
export * from "./IndexPortfolio.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./IndexPortfolio.vue?vue&type=style&index=0&id=d5cc1746&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cc1746",
  null
  
)

export default component.exports